<template>
  <h1 class="epson_fun text-center">
    <a v-on:click="clickLink()" class="gallery_top_link">
      <div class="func-search-gallery text-center">
        <img :src="app_root + '/assets/common/img/gallery_icon_horizontal.svg'"
          class="gallery_logo"
          alt="Gallery"
        />
        <p class="gallery_concept1">
          <strong><LabelFunMessage fcontId="0" msgkey="140" /></strong>
        </p>
        <p class="gallery_concept2">
          <LabelFunMessage fcontId="0" msgkey="139" />
        </p>
      </div> 
    </a>
  </h1>
</template>

<script>
import LabelFunMessage from "./LabelFunMessage";

export default {
  name: "FuncSearchGallery",
  components: {
    LabelFunMessage
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  methods: {
    clickLink: function() {
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "gallery_logo"
      })

      if(this.$route.path !== '/' + this.$store.state.lg2 + '/'){
        this.$router.push({ 
          path: '/' + this.$store.state.lg2 + '/',
          query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale }
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.epson_fun {
  margin-top: 30px;
  margin-bottom: 30px;
}
.func-search-gallery {
  display: inline-block;
  transition: opacity 0.2s;
}
.func-search-gallery:hover {
  opacity: 0.7;
}
.gallery_top_link {
  color: black;
  text-decoration: none;
}
.gallery_concept1 {
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 10px;
}
.gallery_logo {
  margin-top: 0;
  margin-bottom: 10px;
  width: auto;
  height: 70px;
}
.gallery_concept2 {
  font-size: 14px;
}

@media (max-width: 767px) {
  .epson_fun {
    margin-top: 20px;
  }
  .gallery_concept1 {
    font-size: 13px;
  }
  .gallery_logo {
    height: 60px;
  }
  .gallery_concept2 {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .gallery_logo {
    height: 50px;
  }
}

</style>
